"use client";

import { useEffect, useRef } from "react";

const values = [
  {
    number: "01",
    title: "Atendimento Personalizado",
    description: "Cada aluno recebe um plano de aulas adaptado às suas necessidades, objetivos e limitações físicas.",
  },
  {
    number: "02",
    title: "Excelência Técnica",
    description: "Nossa equipe é constantemente atualizada com as melhores práticas e certificações internacionais.",
  },
  {
    number: "03",
    title: "Ambiente Acolhedor",
    description: "Espaços modernos e confortáveis que transmitem calma, segurança e bem-estar desde a entrada.",
  },
  {
    number: "04",
    title: "Saúde Integral",
    description: "Cuidamos do corpo e da mente através do movimento consciente e das terapias integrativas.",
  },
];

export default function ValuesSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.08 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-32 md:py-44 px-6 md:px-10" style={{ background: 'var(--cream-dark)' }} ref={ref}>
      <div className="max-w-8xl mx-auto">
        <div className="text-center mb-20">
          <span className="reveal-hidden subheading mb-5 block">Nossos Valores</span>
          <h2 className="reveal-hidden reveal-delay-1 font-serif text-forest leading-tight"
            style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)' }}>
            O que nos <span className="italic font-light text-sage">guia</span>
          </h2>
        </div>

        <div className="space-y-0">
          {values?.map((val, i) => (
            <div
              key={val?.number}
              className={`reveal-hidden reveal-delay-${(i % 3) + 1} flex flex-col md:flex-row items-start gap-10 py-14 group cursor-default`}
              style={{ borderBottom: '1px solid rgba(232,226,214,0.7)' }}
            >
              <span className="font-serif font-light flex-shrink-0 transition-colors duration-300 group-hover:opacity-100"
                style={{ fontSize: '4rem', lineHeight: 1, color: 'var(--gold)', opacity: 0.3 }}>
                {val?.number}
              </span>
              <div className="flex-1">
                <h3 className="font-serif mb-4 transition-transform duration-500 group-hover:translate-x-2"
                  style={{ fontSize: '1.6rem', color: 'var(--forest)' }}>
                  {val?.title}
                </h3>
                <p className="leading-relaxed max-w-2xl" style={{ color: 'var(--stone)', fontSize: '1.05rem' }}>{val?.description}</p>
              </div>
              <div className="hidden md:flex items-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: 'var(--gold)' }}>
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}